<template>
  <div class="base-query">
    <loading v-show="loading" />
    <div class="serachBack">
      <slot name="searchBox" />
    </div>
    <div class="tablePage">
      <slot />
    </div>
  </div>
</template>

<script>
import loading from '@/components/Loading/outLoading.vue'

export default {
  name: 'BaseQuery',
  components: {
    loading,
  },

  props: {
    loading: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.base-query {
  position: relative;
  overflow: hidden;
  padding: 20px 0 0 0;

  .serachBack {
    background-color: #fff;
    margin-bottom: 10px;
    position: relative;
    padding: 0 20px 0 20px;
  }

  .tablePage {
    border-top: 1px solid #f5f6f8;
    background-color: #fff;
    padding: 20px 20px 0 20px;
  }

  .refPagination {
    width: 100%;
    background-color: #fff;
  }
}
</style>
